function init_a11y_fixes() {
	window.onload = function() {
		/**
		 * WPForms
		 * 
		 * Add aria-label attributes to form fields missing labels
		 * Fixes a11y "Missing form label" error
		 */
		const recaptcha_hidden    = document.getElementsByClassName('wpforms-recaptcha-hidden');
		const recaptcha_response  = document.getElementsByClassName('g-recaptcha-response');
		const wpforms_smart_phone = document.getElementsByClassName('wpforms-smart-phone-field');
		const dz_hidden_input     = document.getElementsByClassName('dz-hidden-input'); // Form upload dropzone element
		for (const element of recaptcha_hidden) {
			element.setAttribute('aria-label', 'Google reCAPTCHA hidden field');
		}
		for (const element of recaptcha_response) {
			element.setAttribute('aria-label', 'Google reCAPTCHA response field');
		}
		for (const element of wpforms_smart_phone) {
			element.setAttribute('aria-label', 'Temporary phone field');
		}
		for (const element of dz_hidden_input) {
			element.setAttribute('aria-label', 'File upload drop area');
		}
	};
}

export default (
	{
		init_a11y_fixes,
	}
);



// WEBPACK FOOTER //
// ./front-end/src/helpers/accessibility.js